package com.oasisfeng.invaluable.event

internal actual fun batchClockMillis(): Long = (js("Date.now()") as Double).toLong()
